import Client from './Client';

class Metabase extends Client {
    getGeneralDashboardUrl() {
        return this.GET(`/plugins/metabase/dashboard_url`)
            .then(response => response.json())
            .then(json => {
                if (json.url) {
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }

    getProjectDashboardUrl(projectId: string) {
        return this.GET(`/plugins/metabase/project/${projectId}/dashboard_url`)
            .then(response => response.json())
            .then(json => {
                if (json.url) {
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }
}

const MetabaseApi = new Metabase();

export default MetabaseApi;
